class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    this.closeButton = this.querySelector('[data-menu-close]');
    this.button?.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }
  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    document.body.classList.add('scroll-lock');
    this.closeButton?.focus();
  }
  close() {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('scroll-lock');
    this.button?.focus();
  }
}
customElements.define('menu-drawer', MenuDrawer);

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.select = this.querySelector('[data-variant-select]');
    this.idInput = this.querySelector('input[name="id"]');
    this.button = this.querySelector('[type="submit"]');
    this.price = this.querySelector('[data-product-price]');
    this.quantity = this.querySelector('input[name="quantity"]');
    this.select?.addEventListener('change', () => this.updateVariant());
    this.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => this.changeQuantity(-1));
    this.querySelector('[data-quantity-increase]')?.addEventListener('click', () => this.changeQuantity(1));
    if (this.select) this.updateVariant();
  }
  updateVariant() {
    const option = this.select.options[this.select.selectedIndex];
    if (!option?.value) {
      this.idInput.value = '';
      this.button.disabled = true;
      this.button.textContent = this.button.dataset.selectLabel;
      return;
    }
    this.idInput.value = option.value;
    this.button.disabled = option.dataset.available !== 'true';
    this.button.textContent = option.dataset.available === 'true' ? this.button.dataset.addLabel : this.button.dataset.soldLabel;
    if (this.price && option.dataset.price) this.price.textContent = option.dataset.price;
  }
  changeQuantity(delta) {
    if (!this.quantity) return;
    const minimum = Number(this.quantity.min || 1);
    this.quantity.value = Math.max(minimum, Number(this.quantity.value || minimum) + delta);
    this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
customElements.define('product-form', ProductForm);

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const dots = Array.from(gallery.parentElement.querySelectorAll('[data-gallery-dot]'));
  const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const target = items[Number(dot.dataset.galleryDot)];
      target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
  });
  gallery.addEventListener('scroll', () => {
    if (!items.length) return;
    const index = Math.round(gallery.scrollLeft / items[0].getBoundingClientRect().width);
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  }, { passive: true });
});
